export default __webpack_public_path__ + "static/media/library.9c8a948f.png";